/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';

/**
 * 
 * @export
 * @interface GoogleCrossSystemDailyRowData
 */
export interface GoogleCrossSystemDailyRowData {
    /**
     * 
     * @type {Date}
     * @memberof GoogleCrossSystemDailyRowData
     */
    date?: Date;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidSpend?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    paidImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    organicClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    organicImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    sessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    engagedSessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    ga4Purchases?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    ga4Revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    erpOrders?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    erpTurnover?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    datixoOrderEvents?: string;
    /**
     * Completed sales orders in the observed ERP cohort; all project domains and centres.
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    completedOrders?: string | null;
    /**
     * Canonical net goods revenue in project-currency minor units, completed sales only.
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    completedGoodsRevenue?: string | null;
    /**
     * Observed canonical media spend subtotal in project-currency minor units for the whole project, including all domains and centres; null when no media source is observed for this day.
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    mediaSpend?: string | null;
    /**
     * Marketing cohort orders on active project domains and all centres: all non-cancelled ERP orders, including unknown or unset completion status.
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    marketingOrders?: string | null;
    /**
     * Marketing cohort net goods revenue in project-currency minor units on active project domains and all centres: all non-cancelled ERP orders, including unknown or unset completion status.
     * @type {string}
     * @memberof GoogleCrossSystemDailyRowData
     */
    marketingGoodsRevenue?: string | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof GoogleCrossSystemDailyRowData
     */
    mediaSourceQuality?: MediaSourceQuality;
}

/**
 * Check if a given object implements the GoogleCrossSystemDailyRowData interface.
 */
export function instanceOfGoogleCrossSystemDailyRowData(value: object): value is GoogleCrossSystemDailyRowData {
    return true;
}

export function GoogleCrossSystemDailyRowDataFromJSON(json: any): GoogleCrossSystemDailyRowData {
    return GoogleCrossSystemDailyRowDataFromJSONTyped(json, false);
}

export function GoogleCrossSystemDailyRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleCrossSystemDailyRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'paidSpend': json['paidSpend'] == null ? undefined : json['paidSpend'],
        'paidClicks': json['paidClicks'] == null ? undefined : json['paidClicks'],
        'paidImpressions': json['paidImpressions'] == null ? undefined : json['paidImpressions'],
        'organicClicks': json['organicClicks'] == null ? undefined : json['organicClicks'],
        'organicImpressions': json['organicImpressions'] == null ? undefined : json['organicImpressions'],
        'sessions': json['sessions'] == null ? undefined : json['sessions'],
        'engagedSessions': json['engagedSessions'] == null ? undefined : json['engagedSessions'],
        'ga4Purchases': json['ga4Purchases'] == null ? undefined : json['ga4Purchases'],
        'ga4Revenue': json['ga4Revenue'] == null ? undefined : json['ga4Revenue'],
        'erpOrders': json['erpOrders'] == null ? undefined : json['erpOrders'],
        'erpTurnover': json['erpTurnover'] == null ? undefined : json['erpTurnover'],
        'datixoOrderEvents': json['datixoOrderEvents'] == null ? undefined : json['datixoOrderEvents'],
        'completedOrders': json['completedOrders'] === undefined ? undefined : json['completedOrders'] === null ? null : json['completedOrders'],
        'completedGoodsRevenue': json['completedGoodsRevenue'] === undefined ? undefined : json['completedGoodsRevenue'] === null ? null : json['completedGoodsRevenue'],
        'mediaSpend': json['mediaSpend'] === undefined ? undefined : json['mediaSpend'] === null ? null : json['mediaSpend'],
        'marketingOrders': json['marketingOrders'] === undefined ? undefined : json['marketingOrders'] === null ? null : json['marketingOrders'],
        'marketingGoodsRevenue': json['marketingGoodsRevenue'] === undefined ? undefined : json['marketingGoodsRevenue'] === null ? null : json['marketingGoodsRevenue'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
    };
}

export function GoogleCrossSystemDailyRowDataToJSON(json: any): GoogleCrossSystemDailyRowData {
    return GoogleCrossSystemDailyRowDataToJSONTyped(json, false);
}

export function GoogleCrossSystemDailyRowDataToJSONTyped(value?: GoogleCrossSystemDailyRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'paidSpend': value['paidSpend'],
        'paidClicks': value['paidClicks'],
        'paidImpressions': value['paidImpressions'],
        'organicClicks': value['organicClicks'],
        'organicImpressions': value['organicImpressions'],
        'sessions': value['sessions'],
        'engagedSessions': value['engagedSessions'],
        'ga4Purchases': value['ga4Purchases'],
        'ga4Revenue': value['ga4Revenue'],
        'erpOrders': value['erpOrders'],
        'erpTurnover': value['erpTurnover'],
        'datixoOrderEvents': value['datixoOrderEvents'],
        'completedOrders': value['completedOrders'],
        'completedGoodsRevenue': value['completedGoodsRevenue'],
        'mediaSpend': value['mediaSpend'],
        'marketingOrders': value['marketingOrders'],
        'marketingGoodsRevenue': value['marketingGoodsRevenue'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
    };
}

